import { ExamSessionDetails } from '../../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import { toast } from 'react-toastify';
import appApi from '../../../../../../../../../api/app-api';

export const examClassScheduleDeleteOperations = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number,
  sessionId: number | undefined,
  scheduleId: number,
  setSessionDetails: (sessions: ExamSessionDetails[]) => any,
) => {
  try {
    if (!programId || !courseId || !sessionId) {
      toast.warn('לא ניתן לאתר את מזהה התוכנית ו/או הקורס');
      return;
    }
    const res = await appApi.deleteExamClasses(
      programId,
      courseId,
      examId,
      sessionId,
      scheduleId,
    );

    setSessionDetails(res.data.body);
  } catch (e) {
    console.error(
      `examClassScheduleDeleteOperations is failed with the programId: ${programId}, courseId: ${courseId}, examId: ${examId}, sessionId: ${sessionId}, scheduleId: ${scheduleId} with the error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  }
};
